import React from 'react';
import './App.css';
import { CustomRoutes } from 'react-admin';
import { Navigate, Route } from 'react-router-dom';
import authProvider from './authProvider';
import { dataProvider } from './dataProvider';
import { ENTRYPOINT } from './config/entrypoint';
import { HydraAdmin, ResourceGuesser } from '@api-platform/admin';
import { CourseCityDateReviewCodes } from './components/CourseCityDate/CourseCityDateReviewCodes';
import {
  UserCreate,
  UserShow,
  UserEdit,
  UserList,
} from './components/User/Views';
import {
  CompanyCreate,
  CompanyShow,
  CompanyEdit,
  CompanyList,
} from './components/Company/Views';
import {
  CityCreate,
  CityShow,
  CityEdit,
  CityList,
} from './components/City/Views';
import {
  CourseCreate,
  CourseList,
  CourseShow,
} from './components/Course/Views';
import {
  CourseCityEdit,
  CourseCityList,
  CourseCityShow,
  CourseCityDatesEdit,
} from './components/CourseCity/Views';
import {
  CourseCityDateList,
  CourseCityDateShow,
  CourseCityDateEdit,
} from './components/CourseCityDate/Views';
import {
  CategoryCreate,
  CategoryList,
  CategoryShow,
} from './components/Category/Views';
import {
  MediaObjectCreate,
  MediaObjectList,
  MediaObjectShow,
} from './components/MediaObject/Views';
import {
  InquiryEdit,
  InquiryList,
  InquiryShow,
} from './components/Inquiry/Views';
import { ReviewEdit, ReviewList } from './components/Review/Views';
import { CourseClone } from './components/Course/CourseClone';
import CourseGenerate from "./components/Course/CourseGenerate";
import { CourseCalendar } from './components/Course/CourseCalendar';
import { AdminLayout } from './components/AdminLayout';
import { DashboardPage } from './components/Dashboard/DashboardPage';
import { CourseEdit } from './components/Course/Edit';
import { CategoryEdit } from './components/Category/Edit';
import {
  SpammerCreate,
  SpammerList,
  SpammerShow,
} from './components/Spammers/Views';
import { useLocalStorage } from '@uidotdev/usehooks';
import { getTheme } from './helper/themes';

function App() {
  const [themeName, saveThemeName] = useLocalStorage('themeName', null);
  let theme = getTheme(themeName);

  return (
    <HydraAdmin
      basename="/"
      theme={theme}
      darkTheme={null}
      dashboard={DashboardPage}
      entrypoint={ENTRYPOINT}
      dataProvider={dataProvider}
      authProvider={authProvider}
      layout={AdminLayout}
    >
      <ResourceGuesser
        name="courses"
        list={CourseList}
        show={CourseShow}
        create={CourseCreate}
        edit={CourseEdit}
      />
      <ResourceGuesser
        name="course_cities"
        list={CourseCityList}
        show={CourseCityShow}
        create={null}
        edit={CourseCityEdit}
      />
      <ResourceGuesser
        name="course_city_dates"
        list={CourseCityDateList}
        show={CourseCityDateShow}
        create={null}
        edit={CourseCityDateEdit}
      />
      <ResourceGuesser
        name="inquiries"
        list={InquiryList}
        show={InquiryShow}
        create={null}
        edit={InquiryEdit}
      />
      <ResourceGuesser
        name="reviews"
        list={ReviewList}
        create={null}
        edit={ReviewEdit}
      />
      <ResourceGuesser
        name="media_objects"
        list={MediaObjectList}
        show={MediaObjectShow}
        create={MediaObjectCreate}
      />
      {/*<ResourceGuesser*/}
      {/*  name="office_versions"*/}
      {/*/>*/}
      <ResourceGuesser
        name="categories"
        list={CategoryList}
        show={CategoryShow}
        create={CategoryCreate}
        edit={CategoryEdit}
      />
      <ResourceGuesser
        name="cities"
        list={CityList}
        show={CityShow}
        create={CityCreate}
        edit={CityEdit}
      />
      <ResourceGuesser
        name="companies"
        list={CompanyList}
        show={CompanyShow}
        create={CompanyCreate}
        edit={CompanyEdit}
      />
      <ResourceGuesser
        name="users"
        list={UserList}
        show={UserShow}
        create={UserCreate}
        edit={UserEdit}
      />
      <ResourceGuesser
        name="spammers"
        list={SpammerList}
        show={SpammerShow}
        create={SpammerCreate}
        // edit={UserEdit}
      />
      <CustomRoutes>
        <Route path="/seo" element={<Navigate to="/courses" replace />} />
        <Route path="/courses/:id/calendar" element={<CourseCalendar />} />
        <Route path="/courses/:id/clone" element={<CourseClone />} />
        <Route path="/courses/generate" element={<CourseGenerate />} />
        <Route
          path="/course_cities/:id/calendar"
          element={<CourseCityDatesEdit />}
        />
        <Route
          path="/course_city_dates/:id/review-codes"
          element={<CourseCityDateReviewCodes />}
        />
      </CustomRoutes>
    </HydraAdmin>
  );
}

export default App;
